import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "userListingPage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createTextVNode("Manage your "),
    /*#__PURE__*/_createElementVNode("span", null, "Agencies")
  ])
], -1)
const _hoisted_3 = { class: "tableSec" }
const _hoisted_4 = { class: "rightsec" }
const _hoisted_5 = { class: "actionblock" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("View Agency")
const _hoisted_7 = {
  key: 0,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_input_search, {
          value: _ctx.searchAgency,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchAgency) = $event)),
          placeholder: "search by name",
          style: {"width":"200px"},
          allowClear: "",
          onSearch: _ctx.onAgencySearch
        }, null, 8, ["value", "onSearch"])
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.agencyColumns,
        "data-source": _ctx.agencyLists,
        class: "",
        rowKey: "id",
        pagination: false,
        rowClassName: 
            (record, index) => (record.status == '1' ? 'active' : 'inactive')
          
      }, {
        status: _withCtx(({ record }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["status", record.status == '1' ? 'active' : 'inactive'])
          }, [
            _createVNode(_component_a_switch, {
              checked: record.active,
              "onUpdate:checked": ($event: any) => ((record.active) = $event),
              onChange: ($event: any) => (_ctx.changeStatus(record))
            }, null, 8, ["checked", "onUpdate:checked", "onChange"])
          ], 2)
        ]),
        action: _withCtx(({ record }) => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createVNode(_component_EyeOutlined, {
                  onClick: ($event: any) => (_ctx.viewAgency(record)),
                  style: { fontSize: '15px' }
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 1
      }, 8, ["columns", "data-source", "rowClassName"]),
      _createVNode(_component_a_pagination, {
        class: "Tlistpagination",
        "show-size-changer": "",
        current: _ctx.currentPage,
        "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
        pageSize: _ctx.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
        total: _ctx.totalNoofAgencies,
        onChange: _ctx.onPageChange,
        onShowSizeChange: _ctx.onShowSizeChange
      }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
    ]),
    (_ctx.pageLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}